import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=38ab3a7b&scoped=true"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetail.vue?vue&type=style&index=0&id=38ab3a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab3a7b",
  null
  
)

export default component.exports